var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OptionBuilder',{attrs:{"disabled":_vm.disabled,"optionName":"Transcrição por voz","iconName":"PodcastMicrophone","id":"Speechtotext","bottom":"108"},on:{"selliaOptionBuilderClickSpeechtotext":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }